<template>
  <button v-if="camera.inst" @click="fit" class="round-button fit__button bg-white bg-opacity-75">
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"></path></svg>
    <div v-if="!isMobile" class="round-button__alt-text">fit zoom</div>
  </button>
</template>

<script>
  import { mapGetters, mapActions} from 'vuex'
  import { isMobile } from 'mobile-device-detect';

  export default {
    name: "FitController",
    data() {
      return {
        isMobile: isMobile,
      }
    },
    computed: {
      ...mapGetters('camera',[
        'camera'
      ])
    },
    methods: {
      ...mapActions('camera',[
        'fit'
      ]),
    }
  }
</script>

<style scoped>

  .fit__button {
    justify-content: center;
    align-items: center;
    display: flex;
    padding: 0;
    height: 40px;
    width: 40px;
    line-height: 40px;
    border-radius: 40px;
  }

  /*.fit__button {*/
    /*height: 40px;*/
    /*width: 40px;*/
    /*line-height: 40px;*/
    /*text-align: center;*/
    /*border: 1px solid black;*/
    /*border-radius: 40px;*/
  /*}*/

</style>